window.$ = window.jQuery = require('jquery');
window._ = require('lodash');

require('popper.js')
require('bootstrap');
require('big.js');